import "core-js/modules/es.function.name";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import parse from 'date-fns/parse';
import CodeTable from '../App/CodetableService';
/**
 * Represents the submitted application and its list of programs data model.
 * @class SubmittedApplicationsModel
 */

var model =
/**
 * Creates an instance of SubmittedApplicationsModel.
 *
 * @param {any} json input json
 * @memberof SubmittedApplicationsModel
 */
function model(json) {
  var _context;

  _classCallCheck(this, model);

  this.application_id = json.application_id;
  this.submittedOn = parse(json.submittedOn);
  this.name = json.name;
  this.status = new CodeTable(json.status);
  this.applicationPrograms = _mapInstanceProperty(_context = json.applicationPrograms).call(_context, function (applicationProgramJson) {
    var applicationProgram = {
      application_program_id: applicationProgramJson.application_program_id,
      case_id: applicationProgramJson.case_id,
      name: applicationProgramJson.name
    };
    var programStatusDetails = {
      canBeWithdrawn: applicationProgramJson.programStatusDetails.canBeWithdrawn,
      hasPendingWithdrawalRequest: applicationProgramJson.programStatusDetails.hasPendingWithdrawalRequest,
      status: new CodeTable(applicationProgramJson.programStatusDetails.status)
    };
    programStatusDetails.withdrawalRequestStatusMessage = applicationProgramJson.programStatusDetails.withdrawalRequestStatusMessage;
    applicationProgram.programStatusDetails = programStatusDetails;
    return applicationProgram;
  });
};

export { model as default };